import { TipoRankingCarteira } from './enum';

export class CarteiraDeIntegradoresRankingFiltro {
  tipoRanking: TipoRankingCarteira;
  tipoFiltroPeriodo: number;
  inicio?: Date;
  fim?: Date;
  idVendedor?: number;
  pesquisaPorTimes: boolean;
}
